module.exports = __webpack_public_path__ + "static/media/avatars_male_27.e03b928b.png";